<template>
  <div class="depart">
    <el-form :model="invoiceData" label-width="110px" :rules="rules" ref="ruleForm" size="medium">
      <div-border label="开票选择" divStyle="margin-top: 10px">
        <el-form-item label="发票寄送方式：" prop="type" style="margin-top: 15px;">
          <el-radio v-model="invoiceData.type" :label="1">快递</el-radio>
          <el-radio v-model="invoiceData.type" :label="0">其它</el-radio>
        </el-form-item>
        <el-form-item v-if="invoiceData.type===1" label="快递类型：" prop="model">
          <el-input
            :style="'width:100%'"
            v-model="invoiceData.model"
            placeholder="请输入快递类型"
            autocomplete="off"
            size="mini"
          />
        </el-form-item>
        <el-form-item v-if="invoiceData.type===1" label="快递单号：" prop="num">
          <el-input
            :style="'width:100%'"
            v-model="invoiceData.num"
            placeholder="请输入快递单号"
            autocomplete="off"
            size="mini"
          />
        </el-form-item>
        <el-form-item label="寄送日期：" prop="date" style="margin-bottom: 20px;">
          <el-date-picker
            v-model="invoiceData.date"
            type="date"
            value-format="yyyy-MM-dd"
            size="mini"
            placeholder="选择寄送日期"/>
        </el-form-item>
        <el-form-item label="备注：" prop="remark">
          <el-input
            :style="'width:100%'"
            type="textarea"
            v-model="invoiceData.remark"
            placeholder="请输入备注"
            autocomplete="off"
            size="mini"
          />
        </el-form-item>
      </div-border>
      <div class="btnContainer">
        <slot name="determine" :invoiceData="invoiceData"></slot>
        <slot name="close" ></slot>
<!--        <el-button class="searchBtn" @click="addClick">确定</el-button>-->
<!--        <el-button class="resetBtn" @click="invoiceClose">关闭</el-button>-->
      </div>
    </el-form>
  </div>
</template>

<script>
    export default {
        name: "invoice",
      components:{},
      data(){
          return{
            invoiceData:{},
            rules:{
              num:[
                { required: true, message: '请输入快递单号', trigger: 'blur' },
              ],
              date:[
                { required: true, message: '请选择寄送日期', trigger: 'change' },
              ],
              model:[
                { required: true, message: '请输入快递类型', trigger: 'blur' },
              ],
              type:[
                { required: true, message: '请选择发票寄送方式', trigger: 'change' },
              ],
            },
          }
      },
      methods:{

      },
    }
</script>

<style lang="scss" scoped>
  .depart{
    width:100%;
    padding: 10px 40px 10px 10px;
    max-height:75vh;
    overflow:auto;
    &Table{
      margin-bottom: 25px;
      width: 100%;
      .tableAddBtnContainer{
        border: 1px solid #EBEEF5;;
        border-top-style: none;
        width: 100%;
        height: 35px;
        display: flex;
        align-items: center;
        padding-left: 15px;
        .AddContainer{
          display: flex;
          align-items: center;
          &:hover{
            cursor: pointer;
          }
        }
        img{
          object-fit: cover;
          margin-right: 5px;
        }
        p{
          font-size: 13px;
          color: #F59A23;
          font-family: 'Arial Normal', 'Arial', sans-serif;
        }
      }
      ::v-deep{
        .el-table .cell {
          padding: 0;
        }
        .el-table th{
          padding: 0;
        }
        .el-table td{
          padding: 0;
        }
      }
    }
    .specialItem{
      ::v-deep {
        .el-form-item__content{
          margin-left: 0!important;
        }
      }
    }
    ::v-deep{
      .el-form-item__label{
        font-weight: 700;
      }
      .el-form-item{
        margin-bottom:13px;
      }
      .el-form-item__label{
        padding:0;
      }
      .el-form-item__content{
        position: relative;
      }
    }
    .btnContainer{
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 30px 0 10px 0;
      button{
        margin: 0 15px;
      }
    }
  }
</style>
